module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div id=\'details-accordion\'></div>\n<div id=\'circuit-schedules-accordion\'></div>\n';

}
return __p
}